module.exports = __webpack_public_path__ + "img/img_tinhnangnoibat.7d2b8fbc.png";